import React, { Component } from "react";
import { t, format_date } from "./CustomComponent.js";

// กระดิ่งแจ้งเตือนใน header admin (presentational — state/การโหลดอยู่ที่ NavbarAdmin)
export default class AlertBell extends Component {
  state = { open: false };
  wrapper = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutside);
    document.addEventListener("keydown", this.handleKey);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutside);
    document.removeEventListener("keydown", this.handleKey);
  }
  handleOutside = (e) => {
    if (this.state.open && this.wrapper.current && !this.wrapper.current.contains(e.target)) {
      this.setState({ open: false });
    }
  };
  handleKey = (e) => {
    if (e.key === "Escape" && this.state.open) this.setState({ open: false });
  };
  toggle = () => {
    const open = !this.state.open;
    this.setState({ open });
    if (open && this.props.onOpen) this.props.onOpen();
  };
  openItem = async (item) => {
    if (!item.is_read && this.props.onRead) await this.props.onRead(item);
    if (item.link) window.location.href = item.link;
    else this.setState({ open: false });
  };

  render() {
    const { unread = 0, items = [], loading = false, className = "" } = this.props;
    const { open } = this.state;
    return (
      <div className={`position-relative ${className}`} ref={this.wrapper}>
        <button
          type="button"
          className="btn border-0 position-relative p-2 text-secondary"
          onClick={this.toggle}
          aria-label={t("alert_bell_title")}
          aria-haspopup="true"
          aria-expanded={open}
          title={t("alert_bell_title")}
          style={{ minWidth: 40, minHeight: 40 }}
        >
          <span className="icon" style={{ fontSize: 18 }}>{""}</span>
          {unread > 0 && (
            <span
              className="position-absolute badge rounded-pill"
              style={{ top: 2, right: 0, backgroundColor: "#D64545", color: "#fff", fontSize: 10 }}
            >
              {unread > 99 ? "99+" : unread}
            </span>
          )}
        </button>
        {open && (
          <div
            className="position-absolute bg-white rounded-lg shadow border"
            style={{ right: 0, top: "100%", width: 360, maxWidth: "92vw", zIndex: 1050 }}
            role="menu"
          >
            <div className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
              <span className="fw-semibold text-14">{t("alert_bell_title")}</span>
              <button
                type="button"
                className="btn btn-link btn-sm p-0 text-12 text-decoration-none"
                disabled={unread === 0}
                onClick={() => this.props.onReadAll && this.props.onReadAll()}
              >
                {t("alert_bell_read_all")}
              </button>
            </div>
            <div style={{ maxHeight: 400, overflowY: "auto" }}>
              {items.length === 0 ? (
                <div className="text-center text-secondary text-14 py-4 px-3">
                  {loading ? t("loading") : t("alert_bell_empty")}
                </div>
              ) : (
                items.map((item) => (
                  <button
                    type="button"
                    key={item.uid}
                    role="menuitem"
                    onClick={() => this.openItem(item)}
                    className="d-flex w-100 text-start border-0 border-bottom px-3 py-2"
                    style={{ backgroundColor: item.is_read ? "#fff" : "#EEF3FF" }}
                  >
                    <span
                      className="rounded-circle flex-shrink-0 mt-2 me-2"
                      style={{ width: 8, height: 8, backgroundColor: item.is_read ? "transparent" : "#2A55E5" }}
                    />
                    <span className="flex-grow-1 overflow-hidden">
                      <span className={`d-block text-14 ${item.is_read ? "" : "fw-semibold"} text-dark`}>
                        {item.title}
                      </span>
                      {item.message && (
                        <span className="d-block text-12 text-secondary" style={{ whiteSpace: "normal" }}>
                          {item.message}
                        </span>
                      )}
                      <span className="d-block text-12 text-secondary mt-1">
                        {format_date(item.created_at, "dd/mm/yyyy hh:mm", "en")}
                      </span>
                    </span>
                  </button>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
